interface PaymentSummaryProps {
  orderAmount: number;
  depositAmount: number;
  isCreditApplied: boolean;
  loading?: boolean;
}

export function PaymentSummary({ orderAmount, depositAmount, isCreditApplied, loading }: PaymentSummaryProps) {
  // const total = orderAmount + depositAmount;
  const total = orderAmount;

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      <div className="text-sm font-bold text-gray-900 mb-2.5">
        {loading ? (
          <span className="inline-block w-16 h-4 rounded animate-pulse" style={{ background: "#E5E7EB" }} />
        ) : (
          "支付明细"
        )}
      </div>
      <div className="space-y-2">
        {loading ? (
          <>
            <div className="flex items-center justify-between py-1.5">
              <span className="inline-block w-16 h-3.5 rounded animate-pulse" style={{ background: "#E5E7EB" }} />
              <span className="inline-block w-20 h-4 rounded animate-pulse" style={{ background: "#E5E7EB" }} />
            </div>
            <div className="flex items-center justify-between py-1.5">
              <span className="inline-block w-16 h-4 rounded font-bold animate-pulse" style={{ background: "#E5E7EB" }} />
              <span className="inline-block w-24 h-6 rounded animate-pulse" style={{ background: "#FEE2E2" }} />
            </div>
          </>
        ) : ([
          { label: "订单金额", value: `¥${orderAmount.toLocaleString()}`, bold: false } as const,
          { label: "实付合计", value: `¥${total.toLocaleString()}`, bold: true } as const,
        ] as Array<{ label: string; value: string; bold: boolean; tip?: string; green?: boolean }>).map((row) => (
          <div key={row.label} className="flex items-center justify-between py-1.5" style={{ borderBottom: row.bold ? "none" : "1px solid #F8F8F8" }}>
            <div className="flex items-center gap-1.5">
              <span className={row.bold ? "text-sm font-bold text-gray-900" : "text-xs text-gray-400"}>{row.label}</span>
              {row.tip && <span className="text-xs px-1.5 py-0.5 rounded-full" style={{ background: "#ECFDF5", color: "#059669" }}>{row.tip}</span>}
            </div>
            <span
              className={row.bold ? "text-lg font-bold" : "text-sm font-medium"}
              style={{ color: row.green ? "#10B981" : row.bold ? "#EF4444" : "#374151" }}
            >
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
